import { render, staticRenderFns } from "./NewEntity.vue?vue&type=template&id=39c4bc3c"
import script from "./NewEntity.vue?vue&type=script&lang=js"
export * from "./NewEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports